import { useEffect } from 'react';
import EscaloneLoading from './EscaloneLoading';
import { useNavigate } from 'react-router-dom';

interface AuthRedirectProps {
  onLogout: () => void;
}

const AuthRedirect = ({ onLogout }: AuthRedirectProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Força o logout
    onLogout();

    // Pega o email da URL se existir
    const params = new URLSearchParams(window.location.search);
    const email = params.get('email');

    // Verifica se já existe usuário com este email
    const users = JSON.parse(localStorage.getItem('users') || '[]');
    const userExists = users.some((user: any) => user.email === email);

    if (userExists) {
      // Se existe, vai para login
      navigate('/login', { 
        state: { 
          email,
          message: 'Usuário já cadastrado. Por favor, faça login.'
        }
      });
    } else {
      // Se não existe, vai para cadastro
      navigate('/cadastro', { 
        state: { email }
      });
    }
  }, [onLogout, navigate]);

  return <EscaloneLoading />;
};

export default AuthRedirect;